import axiosInstance from "../../axios/axios";
import { HorseGender } from "../../pages/services/shared/utils/ServicesConstants";

export const createOrEditIBCApi = (payload) => {
    return axiosInstance.post("/InternationalBreedingCertificate/CreateOrEdit", payload);
};

export const getEligibleSemenCollectionCertificatesApi = (ownerId) => {
    const url = `/InternationalBreedingCertificate/GetEligibleSemenCollectionCertificates${ownerId ? `?ownerId=${ownerId}` : ''}`;
    return axiosInstance.get(url).catch((err) => {
        console.warn("Could not fetch eligible semen collection certificates, trying fallback:", err);
        if (ownerId) {
            return axiosInstance.get(`/EmbryoTransferRightPurchaceAgreementRequest/OwnerCoveringCertificatesDropDown?ownerId=${ownerId}`);
        }
        throw err;
    });
};

export const searchUnregisteredMaresApi = (searchTerm) => {
    return axiosInstance.get(`/servicesrequests/searchunregistredhorses?searchTerm=${encodeURIComponent(searchTerm || '')}&gender=${HorseGender.MARE}`);
};
